import {formatCurrencyMoney} from "../../../lib/formatter.js";
export const moneyRenderer = (text, language, currencyCode) => {
  if (/^$|^null$|^undefined$/.test(text))
    return "-";
  return formatCurrencyMoney(parseFloat(text), currencyCode);
};
